export const articles = [
  {
    id: 1,
    title: '《流浪地球3》定档2027年春节，郭帆透露全新剧情走向',
    slug: 'wandering-earth-3-release-2027',
    category: '电影资讯',
    author: '影视编辑部',
    date: '2026-08-05',
    readTime: '8分钟',
    views: 52800,
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20scene%20with%20futuristic%20space%20station%20and%20glowing%20nebula%2C%20dramatic%20warm%20orange%20and%20gold%20lighting%2C%20epic%20cinematic%20composition%2C%20clean%20dark%20background%2C%20professional%20film%20poster%20style&width=1200&height=630&seq=article-cover-01&orientation=landscape',
    summary: '备受期待的国产科幻巨制《流浪地球3》正式定档2027年大年初一。导演郭帆在最新采访中透露，第三部将继续推进人类带着地球流浪的宏大叙事......',
    content: `备受期待的国产科幻巨制《流浪地球3》正式定档2027年大年初一。导演郭帆在最新采访中透露了诸多关于第三部的创作细节。

郭帆表示，第三部将继续推进人类带着地球流浪的宏大叙事，但故事将进入一个全新的阶段。"如果说前两部是关于'启程'和'危机'，那么第三部将聚焦于'希望'和'归宿'。"

据悉，《流浪地球3》的制作规模将全面超越前两部。特效团队已经从原来的300人扩充到600人，预计特效镜头将超过2000个。郭帆特别强调，第三部将加入更多中国传统文化元素，"我们希望通过科幻的形式，展现中国人独特的家园情怀。"

在演员阵容方面，吴京将继续出演核心角色，同时将有多位实力派演员加盟。据业内人士透露，影片的投资规模已超过10亿元人民币，有望成为中国电影史上投资最高的科幻电影。

值得一提的是，《流浪地球》系列已经成为中国科幻电影的标杆之作。前两部累计票房超过100亿元人民币，在全球科幻电影市场上占据重要地位。第三部的定档消息一经发布，立即引发了影迷的热烈讨论，社交媒体上相关话题阅读量已突破5亿次。

郭帆最后表示："我们希望通过《流浪地球》系列，向世界证明中国科幻电影的实力。第三部将会是系列中最宏大、最震撼的一部，我们正在全力以赴。"`,
    tags: ['流浪地球', '科幻电影', '郭帆', '国产大片', '春节档'],
  },
  {
    id: 2,
    title: '《乘风破浪的姐姐》第四季开播即爆，收视率创新高',
    slug: 'sisters-who-make-waves-season-4',
    category: '综艺热点',
    author: '综艺频道',
    date: '2026-08-04',
    readTime: '6分钟',
    views: 38900,
    cover: 'https://readdy.ai/api/search-image?query=Elegant%20variety%20show%20stage%20with%20shimmering%20golden%20spotlights%2C%20glamorous%20performance%20atmosphere%20with%20rose%20and%20amber%20lighting%2C%20clean%20dark%20stage%20background%2C%20entertainment%20show%20visual%20style&width=1200&height=630&seq=article-cover-02&orientation=landscape',
    summary: '《乘风破浪的姐姐》第四季首播即创下收视新高，全新的嘉宾阵容和赛制设计让这档现象级综艺再度引发全网热议......',
    content: `《乘风破浪的姐姐》第四季于8月1日正式开播，首期节目收视率高达3.8%，创下该系列节目开播以来的最高纪录。

本季最大的亮点在于全新的"团队对抗"赛制。与往季不同，第四季将30位姐姐分成6个五人团队，从第一期开始就以团队形式进行竞争。这种赛制设计让节目节奏更加紧凑，也增加了团队协作的看点。

在嘉宾阵容方面，本季邀请了多位重量级女艺人加盟。包括了实力唱将、当红演员、退役运动员等多元背景的嘉宾，年龄跨度从28岁到55岁，展现了不同年龄层女性的魅力。

节目总监制表示："第四季我们希望在保持节目核心精神的同时，探索更多可能性。我们想展现的不只是舞台表演，更是女性之间的友谊、成长和突破。"

首期节目中，多个舞台表演获得了观众高度评价。尤其是一组以"中国风"为主题的舞台秀，融合了京剧、舞蹈和现代音乐元素，在社交媒体上引发了广泛传播。

平台数据显示，首播后24小时内，#乘风破浪的姐姐第四季# 话题阅读量突破15亿次，讨论量超过800万条。节目相关短视频在全平台的播放量累计超过20亿次，再次证明了这档综艺节目的强大影响力。`,
    tags: ['综艺', '乘风破浪', '收视率', '女团', '舞台表演'],
  },
  {
    id: 3,
    title: '《长安三万里》续集官宣：将讲述李白晚年传奇故事',
    slug: 'chang-an-sequel-announcement',
    category: '动漫资讯',
    author: '动漫编辑部',
    date: '2026-08-03',
    readTime: '7分钟',
    views: 62100,
    cover: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20dynasty%20animated%20scene%20with%20golden%20palace%20and%20cherry%20blossoms%2C%20warm%20sunset%20lighting%20with%20soft%20amber%20and%20rose%20tones%2C%20traditional%20Chinese%20aesthetic%2C%20cinematic%20animation%20style&width=1200&height=630&seq=article-cover-03&orientation=landscape',
    summary: '追光动画正式宣布启动《长安三万里》续集制作，故事将聚焦李白晚年的传奇经历，预计2028年暑期上映......',
    content: `追光动画正式宣布启动《长安三万里》续集制作。这部以盛唐诗人为主角的动画电影，前作曾创下中国动画电影的票房纪录，全球票房突破80亿元人民币。

续集将聚焦于"诗仙"李白的晚年传奇经历。导演邹靖透露，续集的故事时间线将跨越从安史之乱到李白逝世这十余年间。这一时期正是李白人生最为跌宕起伏的阶段——他经历了理想破灭、流放夜郎、获赦归来的大起大落。

"我们想通过李白的晚年故事，展现一个更加真实、更加复杂的人物形象。"邹靖表示，"如果说第一部是青春、梦想和友情的颂歌，那么第二部将是关于坚持、放下和超越的深层思考。"

在制作层面，续集将采用更加先进的动画技术。追光动画CEO王微确认，续集的制作预算将超过前作的5亿元人民币，制作周期预计为两年。团队将采用新一代的渲染技术，力求在视觉呈现上达到世界顶级水平。

业内人士分析认为，《长安三万里》续集的官宣将进一步推动中国动画电影的发展。前作在全球范围内的成功，已经证明了中国传统文化题材在动画领域的巨大潜力。

值得一提的是，前作中的其他诗人角色如杜甫、王维等也将在续集中以不同方式出现，继续构建那个诗意盎然的盛唐世界。`,
    tags: ['长安三万里', '李白', '追光动画', '国漫', '动画电影'],
  },
  {
    id: 4,
    title: '《舌尖上的中国》第五季首播：用镜头记录时代变迁中的美食',
    slug: 'bite-of-china-season-5-premiere',
    category: '纪录片推荐',
    author: '纪录片频道',
    date: '2026-08-02',
    readTime: '5分钟',
    views: 28500,
    cover: 'https://readdy.ai/api/search-image?query=Close-up%20of%20steaming%20Chinese%20cuisine%20with%20golden%20warm%20lighting%2C%20traditional%20cooking%20scene%20with%20rich%20amber%20and%20coral%20tones%2C%20soft%20steam%20rising%20from%20hot%20dishes%2C%20clean%20dark%20background%2C%20food%20documentary%20style&width=1200&height=630&seq=article-cover-04&orientation=landscape',
    summary: '《舌尖上的中国》第五季正式开播，新一季节目不再局限于美食本身，而是通过美食透视中国社会的时代变迁......',
    content: `《舌尖上的中国》第五季于7月30日在91在线观看平台独家首播。作为中国最具影响力的美食纪录片IP，新一季节目带来了令人耳目一新的视角。

总导演陈晓卿表示，第五季最大的变化在于"从美食看时代"。节目不再局限于介绍各地美食的制作过程和背后的文化故事，而是通过美食这个窗口，去观察中国社会在过去几十年间的深刻变迁。

第一集《迁徙的味道》讲述了大量农村人口涌入城市后，各地小吃如何在城市扎根、演变的过程。从重庆小面到柳州螺蛳粉，从沙县小吃到兰州拉面，这些源自地方的美食如何成为全国性的饮食文化符号。

在拍摄手法上，第五季采用了最新的4K HDR技术，画面的色彩和细节表现力达到了新的高度。每一帧画面都堪称视觉盛宴，食物的质感、蒸汽的飘散、油烟的光泽都被细腻地捕捉。

据平台数据显示，首播当晚观看量突破3000万次，弹幕数量超过200万条。许多网友表示，"看饿了"、"每一帧都是壁纸"、"这不仅是一档美食节目，更是一部中国社会变迁的影像志"。

第五季共8集，每周更新一集，将陆续展现不同主题的美食故事。陈晓卿透露，后续剧集将涉及外卖经济、预制菜产业、乡村振兴等与美食相关的社会热点话题。`,
    tags: ['纪录片', '美食', '舌尖上的中国', '社会变迁', '文化'],
  },
  {
    id: 5,
    title: '《孤注一掷2》上映首周票房突破25亿，反诈题材再创奇迹',
    slug: 'no-more-bets-2-box-office',
    category: '电影资讯',
    author: '影视编辑部',
    date: '2026-08-01',
    readTime: '6分钟',
    views: 45600,
    cover: 'https://readdy.ai/api/search-image?query=Intense%20crime%20thriller%20cinematic%20scene%20with%20dramatic%20warm%20and%20dark%20contrast%20lighting%2C%20golden%20and%20deep%20crimson%20accents%2C%20clean%20dark%20background%2C%20professional%20film%20poster%20style&width=1200&height=630&seq=article-cover-05&orientation=landscape',
    summary: '《孤注一掷2》上映首周票房突破25亿元，超越前作同期成绩，反诈题材再次引发全民关注热潮......',
    content: `《孤注一掷2》上映首周票房突破25亿元人民币，不仅超越前作同期成绩，更创造了国产犯罪题材电影的首周票房新纪录。

作为2024年现象级电影《孤注一掷》的续集，第二部延续了反诈题材，但视角更加多元。影片通过三个独立的诈骗案例，深入揭露了电信诈骗、虚拟货币诈骗和AI诈骗等新型犯罪手法。

导演申奥表示："第一部更多是展示诈骗的恐怖，第二部我们想深入探讨诈骗背后的社会原因和人性弱点。"影片在保持悬疑刺激的同时，加入了更多对受害者和诈骗者心理的刻画。

在演员表现方面，张艺兴的演技获得了评论界的一致好评。他在片中饰演一名深入诈骗窝点的卧底警察，将角色的挣扎、恐惧和坚持演绎得入木三分。金晨、王传君等原班人马也悉数回归。

值得关注的是，《孤注一掷2》在社会价值层面产生了远超预期的正面影响。据公安部反诈中心数据，影片上映期间，全国电信诈骗案件同比下降了12%。多个城市在影院设立了反诈宣传站，将观影与社会教育有机结合。

业内人士认为，《孤注一掷》系列的成功为中国类型片发展提供了重要参考——既有商业价值，又有社会意义，实现了艺术性与话题性的双赢。`,
    tags: ['孤注一掷', '反诈', '票房', '犯罪片', '社会议题'],
  },
  {
    id: 6,
    title: '2026年中国短视频行业趋势分析：AI创作与内容生态变革',
    slug: 'short-video-trends-2026',
    category: '行业观察',
    author: '行业研究部',
    date: '2026-07-30',
    readTime: '10分钟',
    views: 19200,
    cover: 'https://readdy.ai/api/search-image?query=Modern%20digital%20content%20creation%20workspace%20with%20warm%20ambient%20lighting%2C%20smartphone%20and%20laptop%20displaying%20video%20editing%20interface%2C%20soft%20golden%20and%20amber%20tones%2C%20clean%20minimal%20background%2C%20tech%20lifestyle%20style&width=1200&height=630&seq=article-cover-06&orientation=landscape',
    summary: '2026年中国短视频行业迎来新一轮变革，AI生成内容、虚拟人主播和垂直领域深耕成为三大趋势......',
    content: `2026年，中国短视频行业延续高速增长态势，用户规模已突破11亿，日均使用时长达140分钟。在这一背景下，行业呈现出三大显著趋势。

第一，AI生成内容（AIGC）全面渗透。据行业报告显示，2026年有超过35%的短视频内容在制作过程中使用了AI工具辅助。从AI脚本生成、智能剪辑到虚拟场景搭建，AI技术正在大幅降低内容创作门槛。多位头部创作者表示，AI工具让他们的生产效率提升了3-5倍。

第二，虚拟人主播成为新赛道。今年以来，已有超过200个品牌推出了专属虚拟人IP，在短视频平台上进行常态化内容输出和直播带货。虚拟人不受时间和空间限制，可以实现24小时不间断内容生产，且人设稳定可控。

第三，垂直领域内容深耕成为增长关键。泛娱乐内容增长趋缓，而教育科普、职业技能、健康养生、法律财经等垂直领域的内容增长迅猛。平台也在通过流量扶持计划，引导创作者向专业化方向发展。

在商业模式层面，短视频平台的收入结构正在从广告为主向多元变现转变。直播电商、知识付费、内容授权等新商业模式增长显著。预计2026年全年，中国短视频行业的市场规模将突破1.5万亿元。

然而，行业也面临着内容同质化、版权争议、未成年保护等挑战。监管部门近期出台了多项政策，引导行业健康有序发展。业内普遍认为，在监管趋严和竞争加剧的双重背景下，内容质量和创新能力将成为决定平台和创作者长期竞争力的关键因素。`,
    tags: ['短视频', '行业分析', 'AI', '虚拟人', '内容生态'],
  },
];